import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/forge-viewer/ForgeViewer.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { useStore } from 'effector-react';
import { ForgeViewer } from '@gmini/forge-viewer';
import { Cover, Parallelepiped } from '@gmini/ui-kit';
import { extensionsToLoad$, getExtensionToLoad } from "./extensions/extensionManager";
import { useEffect } from 'react';
import { selectionService } from "./service";
import { resetMultiplySelect, showElementsInViewer } from "./model/selectModel";
import { loadedModels$, removeLoadedModel, resetLoadedModels, updateLoadedModels } from "./model/loadedModel";
import { findElementFromViewer } from "./service/findElemetFromViewer";
import { useView } from "./hooks/useView";
import { useSelect } from "./hooks/useSelect";
import { useSearch } from "./hooks/useSearch";
import { useLoadModels } from "./hooks/useLoadModels";
import { useError } from "./hooks/useError";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var selectedElements$ = selectionService.selectedElements$;
var ViewerComponent = /*#__PURE__*/React.memo(function (_ref) {
  var selectedModels = _ref.selectedModels,
      resetSearchNodes = _ref.resetSearchNodes,
      selectViewerElements = _ref.selectViewerElements,
      colorViewerElements = _ref.colorViewerElements,
      resetSelectedModels = _ref.resetSelectedModels,
      defaultThemeColor = _ref.defaultThemeColor,
      getModelUrl = _ref.getModelUrl,
      loadModelByUrl = _ref.loadModelByUrl,
      fetchToken = _ref.fetchToken;

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      themeData = _React$useState2[0],
      setThemeData = _React$useState2[1];

  var extensions = useStore(extensionsToLoad$, {
    loc: {
      file: _effectorFileName,
      line: 47,
      column: 23
    },
    name: "ViewerComponent",
    sid: "ViewerComponent /src/forge-viewer/ForgeViewer.tsx [47, 23]"
  });
  var loadedModels = useStore(loadedModels$, {
    loc: {
      file: _effectorFileName,
      line: 48,
      column: 25
    },
    name: "ViewerComponent",
    sid: "ViewerComponent /src/forge-viewer/ForgeViewer.tsx [48, 25]"
  });

  var _useLoadModels = useLoadModels(selectedModels, loadedModels, updateLoadedModels, removeLoadedModel),
      currentLoadedModels = _useLoadModels.currentLoadedModels,
      reloadModels = _useLoadModels.reloadModels,
      resetModels = _useLoadModels.resetModels,
      onModelLoaded = _useLoadModels.onModelLoaded,
      onModelUnloaded = _useLoadModels.onModelUnloaded;

  var _useError = useError({
    reloadModels: reloadModels,
    resetModels: resetModels,
    loadedModels: loadedModels,
    resetSelectedModels: resetSelectedModels
  }),
      ErrorComponent = _useError.ErrorComponent,
      onError = _useError.onError,
      onLoadModelError = _useError.onLoadModelError;

  var _useSelect = useSelect(),
      resetSelected = _useSelect.resetSelected,
      onSelectElements = _useSelect.onSelectElements,
      selectElements = _useSelect.selectElements,
      selectedElements = _useSelect.selectedElements,
      setSelectElements = _useSelect.setSelectElements;

  var _useView = useView(showElementsInViewer),
      focus = _useView.focus,
      isolate = _useView.isolate,
      isolatedElements = _useView.isolatedElements,
      hideAllExceptElements = _useView.hideAllExceptElements,
      resetView = _useView.resetView,
      focusOnElements = _useView.focusOnElements;

  useSearch({
    resetView: resetView,
    resetSelected: resetSelected,
    resetSearchNodes: resetSearchNodes,
    isolate: isolate,
    focus: focus,
    selectedElements: selectedElements,
    selectViewerElements: selectViewerElements,
    selectElements: setSelectElements,
    findElementFromViewer: findElementFromViewer
  });
  useEffect(function () {
    if (selectedElements) {
      selectionService.setSelectedElements(selectedElements);
    }
  }, [selectedElements]);
  React.useEffect(function () {
    if (colorViewerElements) {
      var subscription = colorViewerElements.watch(setThemeData);
      return function () {
        subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
      };
    }
  }, [colorViewerElements]);
  var extensionsToLoad = React.useCallback(function () {
    return getExtensionToLoad(extensions);
  }, [extensions]);
  React.useEffect(function () {
    return function () {
      resetModels();
      resetSelectedModels();
    };
  }, [resetModels, resetSelectedModels]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Cover, {
      open: !currentLoadedModels.length,
      icon: /*#__PURE__*/_jsx(Parallelepiped, {}),
      title: "\u041C\u043E\u0434\u0435\u043B\u044C \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u0430",
      textColor: "#A2A3B7",
      pb: "46px"
    }), ErrorComponent, /*#__PURE__*/_jsx(ForgeViewer, {
      fetchToken: fetchToken,
      models: currentLoadedModels,
      onError: onError,
      onModelLoaded: onModelLoaded,
      extensionsToLoad: extensionsToLoad,
      onSelectElements: onSelectElements,
      focusOnElements: focusOnElements,
      selectElements: selectElements,
      isolateElements: isolatedElements,
      hideAllExceptElements: hideAllExceptElements,
      themeData: themeData,
      onLoadModelError: onLoadModelError,
      defaultColor: defaultThemeColor,
      onModelUnloaded: onModelUnloaded,
      getModelUrl: getModelUrl,
      loadModelByUrl: loadModelByUrl
    })]
  });
});
ViewerComponent.displayName = 'ViewerComponent';
export { ViewerComponent, findElementFromViewer, resetLoadedModels, resetMultiplySelect, selectedElements$ };